module.exports = __webpack_public_path__ + "img/30f74e8c9b52086235c0407e5fd6c602.png";